import { Grid, Typography } from '@mui/material'
import React from 'react'

export const VehicleInTransferProcess: React.FC = () => {
  return (
    <Grid container item xs={12} style={{ marginBottom: 20 }}>
      <Typography variant="h3">
        Selected Vehicle is in transfer process.
      </Typography>
    </Grid>
  )
}
